"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlchemyConnector = void 0;
const ethers_1 = require("ethers");
const Adapters_1 = require("../../Adapters");
const Web3BaseAdapter_1 = require("../../Adapters/Web3BaseAdapter");
const Types_1 = require("../../Types");
const BaseConnector_1 = require("../BaseConnector");
const API_KEY = "DPREQ9e0Op53wPlvBiUOyPIBFcs8wlPo";
class AlchemyConnector extends BaseConnector_1.BaseConnector {
    constructor(config) {
        super({
            displayName: Types_1.OfflineConnectors.Alchemy,
            isWallet: false,
            name: Types_1.OfflineConnectors.Alchemy,
        }, config);
        this.supportedChainIds = [
            Types_1.EthChainIds.Eth,
            Types_1.EthChainIds.Polygon,
            // ...more
        ];
        if (!this.supportedChainIds.includes(this.config.chainId)) {
            throw new Error(`Alchemy does not support the blockchain "${this.config.blockchain}(${this.config.chainId})`);
        }
    }
    async _connect() {
        const adapter = new Web3BaseAdapter_1.Web3BaseAdapter(this.config);
        adapter.setProvider(new ethers_1.ethers.providers.AlchemyProvider(this.config.chainId, API_KEY));
        const multicall = new Adapters_1.Web3MulticallAdapter(adapter);
        return { adapter, multicall };
    }
}
exports.AlchemyConnector = AlchemyConnector;
